import { render, staticRenderFns } from "./costBreakdownTable.vue?vue&type=template&id=0cd09afb&"
import script from "./costBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./costBreakdownTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports